(() => {
  const roots = document.querySelectorAll('[data-ph-product-landing]:not([data-ph-ready])');

  roots.forEach((root) => {
    root.dataset.phReady = 'true';

    const mainImage = root.querySelector('[data-ph-main-image]');
    const thumbs = Array.from(root.querySelectorAll('[data-ph-thumb]'));
    const variants = Array.from(root.querySelectorAll('[data-ph-variant]'));
    const variantInput = root.querySelector('[data-ph-variant-id]');
    const selectedVariant = root.querySelector('[data-ph-selected-variant]');
    const stickyVariant = root.querySelector('[data-ph-sticky-variant]');
    const price = root.querySelector('[data-ph-price]');
    const comparePrice = root.querySelector('[data-ph-compare-price]');
    const buttonPrice = root.querySelector('[data-ph-button-price]');
    const stickyPrice = root.querySelector('[data-ph-sticky-submit] span');
    const form = root.querySelector('[data-ph-product-form]');
    const message = root.querySelector('[data-ph-cart-message]');
    const sticky = root.querySelector('[data-ph-sticky-cart]');
    const stickySubmit = root.querySelector('[data-ph-sticky-submit]');
    const buybox = root.querySelector('.ph-product-landing__buybox');
    const fomo = root.querySelector('[data-ph-fomo]');

    function setImage(src) {
      if (!mainImage || !src) return;
      mainImage.src = src;
      mainImage.srcset = '';
    }

    function markSelected(items, selected) {
      items.forEach((item) => {
        const isSelected = item === selected;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setImage(thumb.dataset.image);
        markSelected(thumbs, thumb);
      });
    });

    variants.forEach((variant) => {
      variant.addEventListener('click', () => {
        if (variant.disabled) return;

        markSelected(variants, variant);
        if (variantInput) variantInput.value = variant.dataset.variantId;
        if (selectedVariant) selectedVariant.textContent = variant.dataset.variantTitle || '';
        if (stickyVariant) stickyVariant.textContent = variant.dataset.variantTitle || '';
        if (price) price.textContent = variant.dataset.price || '';
        if (buttonPrice) buttonPrice.textContent = variant.dataset.price || '';
        if (stickyPrice) stickyPrice.textContent = variant.dataset.price || '';

        if (comparePrice) {
          comparePrice.textContent = variant.dataset.comparePrice || '';
          comparePrice.hidden = variant.dataset.hasCompare !== 'true';
        }

        setImage(variant.dataset.image);
      });
    });

    async function addToCart(event) {
      event.preventDefault();
      if (!form || !variantInput) return;

      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton?.querySelector('span')?.textContent || '';
      if (submitButton) submitButton.disabled = true;
      if (message) message.textContent = '';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: Number(variantInput.value),
            quantity: 1,
          }),
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Unable to add this item.');
        }

        if (message) message.textContent = 'Added to cart.';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        window.setTimeout(() => {
          window.location.href = '/cart';
        }, 250);
      } catch (error) {
        if (message) message.textContent = error.message;
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          const label = submitButton.querySelector('span');
          if (label && originalText) label.textContent = originalText;
        }
      }
    }

    if (form) form.addEventListener('submit', addToCart);
    if (stickySubmit && form) {
      stickySubmit.addEventListener('click', () => {
        form.requestSubmit();
      });
    }

    if (sticky && buybox) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      );
      observer.observe(buybox);
    }

    if (fomo) {
      const count = fomo.querySelector('[data-ph-fomo-count]');
      let value = Number(count?.textContent || 530);

      function tick() {
        const delay = (Math.floor(Math.random() * 61) + 60) * 1000;
        window.setTimeout(() => {
          value += Math.floor(Math.random() * 3) + 1;
          if (count) count.textContent = String(value);
          tick();
        }, delay);
      }

      tick();
    }
  });
})();
